import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-status.component.html',
  styleUrls: ['./loading-status.component.scss']
})
export class LoadingStatusComponent implements OnInit, OnDestroy {
  loadingMessages = [
    'Authenticating with Azure...',
    'Loading your profile...',
    'Preparing your workspace...',
    'Almost ready...'
  ];
  currentMessageIndex = 0;
  currentMessage = this.loadingMessages[0];
  private messageInterval: any;

  ngOnInit(): void {
    // Prevent body scrolling when loading component is shown
    document.body.classList.add('no-scroll');
    
    // Rotate messages every 2 seconds
    let index = 0;
    this.messageInterval = setInterval(() => {
      index = (index + 1) % this.loadingMessages.length;
      this.currentMessage = this.loadingMessages[index];
      this.currentMessageIndex = index;
    }, 2000);
  }

  ngOnDestroy(): void {
    // Clean up interval
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
    }
    // Remove no-scroll class when component is destroyed
    document.body.classList.remove('no-scroll');
  }
}
